var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08916 2.69052e-05C3.23183 2.69052e-05 4.1552 0.93494 4.1552 2.08338C4.1552 3.2376 3.22029 4.1552 2.05453 4.1552C0.911856 4.14943 -0.005744 3.21451 2.70732e-05 2.0603C0.00579815 0.917627 0.934941 -0.00574417 2.08916 2.69052e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06604 11.0771C0.923371 11.0713 0 10.1422 0 8.99372C0 7.8395 0.934914 6.91613 2.10067 6.9219C3.24334 6.92767 4.16094 7.86259 4.15517 9.0168C4.1494 10.1595 3.22026 11.0771 2.06604 11.0771Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1552 15.9349C4.1552 17.0776 3.22606 18.001 2.07184 18.001C0.917627 18.001 -0.00574417 17.0661 2.69048e-05 15.9061C0.00579798 14.7634 0.940712 13.8458 2.08915 13.8516C3.2376 13.8574 4.1552 14.7865 4.1552 15.9349Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotImg);
export default __webpack_public_path__ + "static/media/three-dot-img.c2cde18bb4c018ce3fef91e40e3bab09.svg";
export { ForwardRef as ReactComponent };